export const urlApi = 'https://paynet.osviel.com:8443';
//export const urlApi = 'http://paynet.osviel.com:8333';
//export const urlApi = 'http://localhost:8089';
//export const urlApi = 'https://paynet.osviel.com:8089';
//export const urlApi = 'http://3.18.36.101:8089';
//export const urlApi = 'http://192.168.0.7:8089';
//export const nitOsviel = "8921200207";
export const nitOsviel = "900344946";